import { inject, Injectable, signal } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  private snackBar = inject(MatSnackBar);

  public innerHeight = signal(0);
  public innerWidth = signal(0);
  
  public openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }

  public setWindowInnerSize(width: number, height: number){
    this.innerHeight.set(height);
    this.innerWidth.set(width);
  }
}
